import { STATUS_META, TEMP_META } from "@/lib/constants";

export function StatusBadge({ status, className = "" }) {
  const meta = STATUS_META[status];
  if (!meta) return null;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-medium badge-${status} ${className}`}
    >
      {meta.label}
    </span>
  );
}

export function TempBadge({ temp, className = "" }) {
  const meta = TEMP_META[temp];
  if (!meta) return null;
  return (
    <span
      data-testid={`temp-badge-${temp}`}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-medium badge-${temp} ${className}`}
    >
      <svg viewBox="0 0 12 12" className="h-2.5 w-2.5" fill="currentColor" aria-hidden>
        <circle cx="6" cy="6" r="2.5" />
      </svg>
      {meta.label}
    </span>
  );
}

export function LeadTypeBadge({ type, className = "" }) {
  const live = type === "live";
  return (
    <span
      data-testid={`lead-type-badge-${live ? "live" : "bulk"}`}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${
        live ? "bg-rose-50 text-rose-600 ring-1 ring-rose-200" : "bg-slate-100 text-slate-600 ring-1 ring-slate-200"
      } ${className}`}
    >
      {live && <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-rose-500" />}
      {live ? "Live" : "Bulk"}
    </span>
  );
}
